export {
  API_URL,
  ENERGY_SHIFT_TARGET_YEAR,
  MATERIALS_AND_METALS_INFO_CARD_URL,
  RESOURCE_CENTER_URL,
  TERMS_OF_USE_URL,
  WEB_SOCKET_URL,
};

const ENERGY_SHIFT_TARGET_YEAR = 2050;
const TERMS_OF_USE_URL =
  "https://ogre-public.s3.eu-west-3.amazonaws.com/cgu-latest.pdf";

const MATERIALS_AND_METALS_INFO_CARD_URL =
  "https://drive.google.com/file/d/1mXoUrtdklLjW1p7RpjJfe_Sj141Z4QC-/view?usp=share_link";

const API_URL = import.meta.env.VITE_API_BASE_URL || "";
const WEB_SOCKET_URL = import.meta.env.VITE_API_BASE_URL || "";
const RESOURCE_CENTER_URL =
  "https://atelier-ogre.notion.site/La-Biblioth-que-OGRE-b91f966f2e7949c79b9eb88b60e5888a";
